export default __webpack_public_path__ + "images/780f683c5eca5e9d925b32f177350965.svg";